import { memo } from 'react';
import { Box, ProgressBar, Text } from '@betty/moonlight';
import QuestProgressLabel from '../../../QuestProgressLabel/QuestProgressLabel';
import { QuestProgressProps } from './QuestProgress.types';

function QuestProgress({
  subTypeMeta,
  subPromoType,
  showMainLabel = false,
  showLeftLabel = false,
}: QuestProgressProps) {
  const progress = Math.max(
    subTypeMeta.currentAccumulation === 0
      ? subTypeMeta.targetAccumulation * 0.05
      : subTypeMeta.currentAccumulation,
    0,
  );

  return (
    <Box flex={1}>
      {showMainLabel ? (
        <Text
          variant="h5"
          gradient="darkSurfaceAccent"
          locNS="quests"
          locKey="yourProgress"
          marginBottom="space-200"
        />
      ) : null}

      <Box
        flexDirection="row"
        gap="space-200"
        justifyContent="center"
        alignItems="center"
        paddingVertical="space-200"
        paddingHorizontal="space-300"
        borderRadius="radius-400"
        backgroundColor={
          showMainLabel || showLeftLabel
            ? 'secondaryBackgroundDefault'
            : undefined
        }
      >
        {showLeftLabel ? (
          <Text
            variant="caption-semi"
            color="darkSurfacePrimary"
            locNS="quests"
            locKey="yourProgress"
          />
        ) : null}

        <ProgressBar
          from={0}
          progress={Math.min(progress, 100)}
          to={subTypeMeta.targetAccumulation}
          flex={1}
        />
        <QuestProgressLabel
          currentAccumulation={Math.min(
            subTypeMeta.currentAccumulation,
            subTypeMeta.targetAccumulation,
          )}
          targetAccumulation={subTypeMeta.targetAccumulation}
          subPromoType={subPromoType}
        />
      </Box>
    </Box>
  );
}

export default memo(QuestProgress);
